export function cn(...classes: (string | false | null | undefined)[]): string {
  return classes.filter(Boolean).join(' ')
}

export function slugify(input: string): string {
  return input
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '')
    .slice(0, 48)
}

import { apiKeyKey } from './storageKeys'

// Gateway keys are bearer credentials independent of the session cookie —
// keep them sessionStorage-scoped (die with the tab), one flat key per org,
// and only ever written by explicit Save / key creation, never implicitly on run.
export function getStoredApiKey(orgId: string): string | null {
  try {
    return sessionStorage.getItem(apiKeyKey(orgId))
  } catch {
    return null
  }
}

export function setStoredApiKey(orgId: string, key: string): void {
  try {
    sessionStorage.setItem(apiKeyKey(orgId), key)
  } catch {
    // ignore quota
  }
}

export function removeStoredApiKey(orgId: string): void {
  try {
    sessionStorage.removeItem(apiKeyKey(orgId))
  } catch {
    // ignore
  }
}

// REACT-URL-001 / JS-URL-002 (security best-practices spec): a server-provided
// string about to become a navigation target (rendered href, location.assign)
// must be a plain http(s) URL — javascript:/data:-style active schemes execute
// in this origin the moment the link is clicked. Returns the input unchanged
// when it parses as http/https, null otherwise (caller renders inert text).
export function safeHttpUrl(raw: string): string | null {
  try {
    const u = new URL(raw)
    return u.protocol === 'https:' || u.protocol === 'http:' ? raw : null
  } catch {
    return null
  }
}

export function toDateInput(iso: string): string {
  return iso.slice(0, 10)
}

export function defaultRange(): { from: string; to: string } {
  const now = new Date()
  return {
    from: toDateInput(new Date(now.getTime() - 7 * 24 * 3600 * 1000).toISOString()),
    to: toDateInput(now.toISOString()),
  }
}
